import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "layout", "max_width", "align_self", "align", "align_items", "justify_items", "vertical_align", "gap"];
import clsx from "clsx";
import React, { useMemo } from "react";
import { createMemoClass } from "../create-memo-class";
import { useMaxWidthClasses } from "../shared-classes";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Grid = _ref => {
  var _router$query;

  var {
    className,
    children,
    layout = "1",
    max_width,
    align_self,
    align,
    align_items,
    justify_items,
    vertical_align,
    gap
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var router = useRouter();
  var classes = useGridClass({
    layout,
    max_width,
    align_self: align_self || align,
    align_items,
    justify_items: justify_items || vertical_align,
    gap
  });
  var cols = {
    "1": 1,
    "1-1": 2,
    "2-1": 2,
    "1-2": 2,
    "3-1": 2,
    "1-3": 2,
    "1-1-1": 3,
    "1-1-1-1": 4
  };
  var count = cols[layout] - React.Children.count(children);
  var preview = (router == null ? void 0 : (_router$query = router.query) == null ? void 0 : _router$query.preview) || true;
  var placeholders = useMemo(() => {
    if (preview && count > 0) return Array.from(Array(count).keys());
    return [];
  }, [preview, count]);
  return /*#__PURE__*/_jsxs("div", _extends({
    className: clsx(classes, className)
  }, rest, {
    children: [children, placeholders.map(i => /*#__PURE__*/_jsx("div", {
      className: "h-full min-h-[20px] bg-black-alpha-100"
    }, i))]
  }));
};
var useGridClass = createMemoClass(props => {
  var layouts = {
    "1": "grid-layout-1",
    "1-1": "grid-layout-1-1",
    "2-1": "grid-layout-2-1",
    "1-2": "grid-layout-1-2",
    "3-1": "grid-layout-3-1",
    "1-3": "grid-layout-1-3",
    "1-1-1": "grid-layout-1-1-1",
    "1-1-1-1": "grid-layout-1-1-1-1"
  };
  var max_width = useMaxWidthClasses(props.max_width);
  var align_self = {
    center: "mx-auto",
    left: "mr-auto",
    right: "ml-auto"
  };
  var align_items = {
    center: "items-center",
    start: "items-start",
    end: "items-end"
  };
  var justify_items = {
    center: "justify-items-center",
    start: "justify-items-start",
    end: "justify-items-end"
  };
  var gaps = {
    "2": "gap-2",
    "4": "gap-4",
    "8": "gap-8",
    "16": "gap-16"
  };
  var classes = clsx("grid grid-cols-1 w-full", layouts[props.layout], max_width, align_self[props.align_self], align_items[props.align_items], justify_items[props.justify_items], gaps[props.gap]);
  return classes;
});
//# sourceMappingURL=grid.js.map